import React, { useState } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,TableContainer,
          Paper,
    TableCell,  Card, Box, Typography,
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import ActivityService from "./Locality/Service/activityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SuperActivityService from "./Locality/Service/superActivityService";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Activity() {
    const tableHeaders = ['Class','Area Of Work', 'List Of Activities', 'Edit', 'Delete'];
    const classes = useStyles();
    const [filterExercise, setExercise] = useState('');
    const [filterActivityList, setFilterActivityList] = useState([]);
    const [filterActivity, setActivity] = useState('');
    const [filterExerciseList, setExerciseList] = useState([]);
    const [temActivitylList, setTempActivityList] = useState([]);
    const [tabelList, setTabelList] = useState([]);
    const [filterSuperActivity, setfilterSuperActivity] = useState('');
    const [classNameList, setClassNameList] = useState([]);
    const [activitylList, setActivityList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [superActivityList, setSuperActivityList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [tabelIdList, setTabelIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [tabel, setTabel] = useState({
        classId: '',
        superActivityId: '',
        activityName: '',
    });
    
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        superActivityId: Yup.string().required('super Activity Name is required'),
        activityName: Yup.string().required('Activity Name is required'),

    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    useEffect(() => {
        getActivityTabelList();
        // getSuperActivityList();
        getAddClassList();
        return () => {
            setTabelIdList([]);
            setSuperActivityList([]);
            setTabelList([]);
            setAddSuperActivityList([]);
            setAddClassList([]);
            // setClassNameList([]);
        }
    }, []);
    const filterSuperActivitys = (event)=>{

        setfilterSuperActivity(event.target.value);
        if(event.target.value){
        
            // const filterValue = temActivitylList.filter(act=>act.superActivityId._id === event.target.value);
            // setActivityList(filterValue);
            const setValues = temActivitylList.map(result=>{
                return {name:result.ActivityName,value:result._id};
            });
            setExerciseList(setValues);
           
        }else{
            setActivityList(temActivitylList);
            const setValues = temActivitylList.map(result=>{
                return {name:result.activityName,value:result._id};
            });
            setExerciseList(setValues);
        }
    
        }
        const filterExcDetails = (event) => {
        const extId = event?event._id:'';
            setExercise(extId);
            if (extId) {
                const filterValue = temActivitylList.filter(act => act._id === extId);
                setTabelList(filterValue);
            } else {
                setTabelList(temActivitylList);
            }
    
        }
 
        const getSuperActivityList = (event, obj) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            const getsupActList = { classId:event.target.value};
    
            SuperActivityService.getAllSuperActivityById(userDetails.schooleId, getsupActList).then((res) => {
                
                setAddSuperActivityList(res);
            }).catch((err) => {
                // setError(err.message);
            });
        }
    const getActivityTabelList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        ActivityTabelService.getAllActivityTabel(userDetails.schooleId).then((res) => {
            setTabelList(res);
            setTempActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getFilterActivityList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const reqBody ={
            schoolId:userDetails.schooleId,
            superActivityId:event.target.value
        }
        setfilterSuperActivity(event.target.value);
        ActivityTabelService.getAllActivityTabeBySuperActivityId(reqBody).then((res) => {
            setTabelList(res);
            setTempActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const handleOpen = (status) => {
        if(status){
            setTabel({
            superActivityId: '',
            activityName: '',
        })
        }
     
          setOpen(true);
      };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };

    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            setAddClassList(res);
            if(res.length>0){
                getSuperActivityList({target:{value:res[0]._id}})
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getClassNameList = (event) => {
        AddClassService.getAddClassNameById({ className: event.target.value }).then((res) => {

            setClassNameList(res);

        }).catch((err) => {
            setError(err.message);
        });
    }
    const editActivityTabel = (tabel) => {
        const obj = JSON.parse(JSON.stringify(tabel));

        obj.superActivityId = tabel.superActivityId ? tabel.superActivityId._id : '';
        obj.classId = tabel.classId ? tabel.classId._id :'';
        getSuperActivityList({target:{value:obj.classId}}) 
        //  tabel.superActivityId = tabel.superActivityId ? tabel.superActivityId._id :''; 
        setTabel(obj)
        handleOpen(false)
    }
    const deleteActivityTabel = (tabeldelete) => {
        if (tabeldelete) {
            ActivityTabelService.deleteActivityTabel(tabeldelete).then((res) => {
                getActivityTabelList();
            }).catch((err) => {
            });
        }
    };
    const formik = useFormik({
        initialValues: tabel,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            if (tabel._id) {
                ActivityTabelService.upadeActivityTabel(values).then((res) => {
                    handleClose();
                    getActivityTabelList();
                    // getSuperActivityList()
                    resetForm()
                    alert("Activity Tabel Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                ActivityTabelService.creteActivityTabel(values).then((res) => {
                    getActivityTabelList();
                    resetForm();
                    handleClose();
                    alert(" Activity Tabel Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {

                        alert(err.response.data.message)
                    })
            }

        },
    });
    return (
        <>
            <PageTitle title="List Of Activities" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Activity
            </Button>} />
            <Box style={{ marginBottom: 16, marginTop: 8, padding: 12, backgroundColor: 'rgba(0,0,0,0.04)', borderRadius: 4 }}>
                <Typography variant="body2" color="textSecondary">
                    By default, all area of work, activities, and exercise are added. If you want to add extra activities, add them here.
                </Typography>
            </Box>
             <Card sx={{ maxWidth: 345 }}>
                <Box style={{margin:"15px"}}  >
            <Grid container spacing={2}>
                <Grid item xs={6}>
                  
                    
                        <FormControl variant="filled" fullWidth="true" >
                            <InputLabel id="demo-simple-select-standard-label"> Area Of Work</InputLabel>
                            <Select
                            
                                labelId="demo-simple-select-standard-label"
                                id="superActivityName"
                                name="superActivityId"
                                label="superActivity"
                                value={filterSuperActivity}
                                onChange={getFilterActivityList}
                           
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addSuperActivityList.map(({ _id, superActivityName }) => (
                                    <MenuItem key={_id} value={_id}>{superActivityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                   
                </Grid>
                {/* <Grid item xs={6}>
                    <div >
                    <Autocomplete
      id="combo-box-demo"
      options={tabelList}
      getOptionLabel={(option) => option.activityName}
      
      onChange={(event, newValue) => {
        filterExcDetails(newValue);
      }}
      renderInput={(params) => <TextField {...params} label="Activities" variant="filled" />}
    />



                  
                    </div>
                </Grid> */}
            </Grid>

            </Box>
            </Card >
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tabelList.slice(pg * rpg, pg * rpg + rpg).map((tabel) => (
                                    <TableRow key={tabel._id}>


                                        <TableCell className="pl-3 fw-normal" >{tabel.classId ? tabel.classId.className : ''}</TableCell>
                                        {/* <TableCell className="pl-3 fw-normal" >{sub.activityId ? sub.activityId.activityName : ''}</TableCell> */}
                                        <TableCell className="pl-3 fw-normal" >{tabel.superActivityId ? tabel.superActivityId.superActivityName : ''}</TableCell>
                                        {/* <TableCell className="pl-3 fw-normal" >{tabel.superActivityName}</TableCell> */}
                                        <TableCell className="pl-3 fw-normal" >{tabel.activityName}</TableCell>
                                        <TableCell>
                                            {tabel.schooleId && (
                                                <EditIcon style={{ cursor: 'pointer' }} onClick={() => editActivityTabel(tabel)} >
                                                </EditIcon >
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {tabel.schooleId && (
                                                <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteActivityTabel(tabel)} />
                                            )}
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[ 50, 500, 10000]}
                            count={tabelList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Activity</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 308 }}>
                    <FormControl className={classes.formControl} fullWidth="true"
                                        >
                                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="classId"
                                                label="selectClass"
                                                value={formik.values.classId}
                                                // value={formik.values.classId}
                                                onChange={e => { formik.handleChange(e);  getSuperActivityList(e) }}
                                                // onChange={formik.handleChange}
                                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                                helperText={formik.touched.classId && formik.errors.classId}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>

                                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}
                                        
                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Area Of Work</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="superActivityName"
                                label="Area Of Work "
                                name="superActivityId"
                                onChange={formik.handleChange}
                                // onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                value={formik.values.superActivityId}
                                error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                helperText={formik.touched.superActivityId && formik.errors.superActivityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addSuperActivityList.map(({ _id, superActivityName }) => (

                                    <MenuItem key={_id} value={_id}>{superActivityName}
                                        {/* <Checkbox checked={formik.values.categoryId.indexOf(parent) > -1} /> */}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            autoFocus
                            margin="dense"
                            id="activityName"
                            name="activityName"
                            label="List Of Activities"
                            type="text"
                            variant="standard"
                            value={formik.values.activityName}
                            onChange={formik.handleChange}
                            error={formik.touched.activityName && Boolean(formik.errors.activityName)}
                            helperText={formik.touched.activityName && formik.errors.activityName}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


